// gallery-home.js
import { toggleLoader, updateURL, transitionPage, setGalleryView, scrollToGalleryTop } from './gallery-functions.js';

export function initGalleryHome() {
    transitionPage(() => {
        setGalleryView('home');
        const galleryMain = document.getElementById('gallery-main');
        galleryMain.style.display = 'flex';
        document.getElementById('patients-container').innerHTML = '';
        scrollToGalleryTop();

        const sidebar = document.querySelector('.gallery-sidebar');
        if (sidebar) {
            sidebar.style.display = 'none';
        }

        loadProcedures();
    });
}

function loadProcedures() {
    toggleLoader(true);
    let xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            toggleLoader(false);
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
                renderProcedures(response.data);
                updateURL({});
            } else {
                document.getElementById('gallery-main').innerHTML = '<p>No procedures found.</p>';
            }
        }
    };
    xhr.send('action=get_procedures');
}

function renderProcedures(procedures) {
    const galleryMain = document.getElementById('gallery-main');
    let proceduresHtml = '';
    procedures.forEach(function(group) {
        proceduresHtml += '<div class="procedures-list">';
        proceduresHtml += '<h3><a href="#" data-id="' + group.parent_id + '" class="procedure-link parent-link">' + group.parent_name + '</a></h3>';
        proceduresHtml += '<ul>';
        group.children.forEach(function(procedure) {
            proceduresHtml += '<li><a href="#" data-id="' + procedure.term_id + '" class="procedure-link">' + procedure.name + '</a></li>';
        });
        proceduresHtml += '</ul></div>';
    });
    galleryMain.innerHTML = proceduresHtml;
    galleryMain.style.display = 'flex';
    document.getElementById('patients-container').innerHTML = '';
}